import { getWorkerUrl } from '../utils/env';
import { ApiResult } from '../types';

export interface PlatformContactData {
    /**
     * @deprecated Ignored by the worker — the recipient is resolved
     * server-side from the listing (security: prevents mailing arbitrary
     * addresses). Kept only for compatibility with older worker deploys.
     */
    owner_email: string;
    customer_email: string;
    customer_phone?: string;
    customer_name?: string;
    reservation_id?: string;
    listing_title: string;
    listing_id: string;
    message?: string;
    type: 'contact' | 'reservation';
    turnstileToken?: string;
}

export const sendPlatformContact = async (data: PlatformContactData): Promise<ApiResult<void>> => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    try {
        const workerUrl = getWorkerUrl('D1');
        const response = await fetch(`${workerUrl}/api/platform/contact`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            signal: controller.signal
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
            const errData = await response.json().catch(() => null);
            return { success: false, error: errData?.error || `Server error: ${response.status}` };
        }

        return { success: true, data: undefined };
    } catch (error: any) {
        clearTimeout(timeoutId);
        if (error.name === 'AbortError') {
            return { success: false, error: 'Request timed out. Please try again.' };
        }
        console.error('Error sending platform contact via proxy:', error);
        return { success: false, error: error.message || 'Unknown network error' };
    }
};
